module.exports = __webpack_public_path__ + "e0068740.png";